<template>
  <div>
    <v-card>
      <v-card-title class="text-h6 blue darken-4 lighten-2 py-2">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="h6" style="color:white!important;">
              <v-icon color="white">mdi-information-outline</v-icon>
              Información de Encuesta
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="mx-2 mt-2">
          <v-col class="text-center" cols="12" md="6">
            <div class="subtitle-1"><b>Nombre de la encuesta</b><br>{{objEncuesta.nombreEncuesta}}</div>          
          </v-col>
          <v-col class="text-center" cols="12" md="3">
            <div class="subtitle-1"><b>Fecha de inicio</b><br>{{ getDateFormated(objEncuesta.fechaInicio) }}</div>          
          </v-col>
          <v-col class="text-center" cols="12" md="3">
            <div class="subtitle-1"><b>Fecha de fin</b><br>{{ getDateFormated(objEncuesta.fechaFin) }}</div>          
          </v-col>
        </v-row>
        <v-row class="mx-2 mt-2">
          <v-col class="text-center d-flex" cols="12" md="6">
            <v-file-input
              v-model="imgEncabezado"
              :loading="loadingImg"
              label="Imagen encabezado"
              outlined
              dense
              accept="image/*"
              :disabled="del"
              @change="fileChanged"
            ></v-file-input>

            <v-tooltip v-if="del == true" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  
                  class="ml-2"
                  color="error"
                  fab
                  small
                  dark
                  :loading="loadingSave"
                  @click.stop="dialogEliminarImg = true"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar imagen de encabezado</span>
            </v-tooltip>

            <v-tooltip v-if="save == true" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  class="ml-2"
                  color="success"
                  fab
                  small
                  dark
                  :loading="loadingSave"
                  @click.stop="guardarImgEncabezado"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Guardar imagen de encabezado</span>
            </v-tooltip>

          </v-col>
          <v-col  cols="6" md="6">
          
            <div class="subtitle-7"><b>Pie de encuesta</b><div v-html="objEncuesta.pieEncuesta"/></div>          
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      :name="'dialog_eliminar_eiarchivo'"
      :key="'dialog_eliminar_eiarchivo'"
      v-model="dialogEliminarImg"
      width="400"
      max-width="400"
      transition="scale-transition" origin="center center"
    >
      <v-card>
        <v-card-title class="text-h5 blue darken-4 lighten-2">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="h5" style="color:white!important;">
                <v-icon color="white">mdi-delete</v-icon>
                Eliminar imagen
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="px-0">
          <v-row class="mx-0 mt-2">
            <v-col class="text-center" cols="12">
              <div class="body-2">
                Esta por eliminar la imagen encabezado de la encuesta, 
                si lo hace ya no se podrá recuperar. 
                ¿Desea continuar?
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2"
            color="default"
            :loading="loadingSave"
            @click="dialogEliminarImg = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="mx-2"
            color="error"
            :loading="loadingSave"
            @click="deleteImagenEncabezado"
          >
          <v-icon class="mr-2">mdi-delete</v-icon>
            Si, eliminar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :name="'snackbar_infoEncuesta'"
      :key="'snackbar_infoEncuesta'"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { getEiArchivoEncuestaByIdEncuestaToken, postEiArchivoEncuesta, deleteEiArchivoEncuesta } from "@/api";
import moment from 'moment';

export default {
  name: "InfoEncuesta",
  components: {
  },
  props: {
    objEncuesta: {
      type: Object,
      default: function () {
        return {
          idEncuesta: 0,
          nombreEncuesta: '',
          objetivo: '',
          tokenEncuesta: '',
          fechaInicio: null,
          fechaFin: null,
         
        }
      }
    },
  },
  data () {
    return {
      loadingImg: false,
      loadingSave: false,
      imgEncabezado: null,
      dialogEliminarImg: false,
      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",
      del:false,
      save:false
    };
  },
  computed: {
  },
  beforeMount () {},
  async mounted () {
    this.obtenerEiArchivoImgEncabezado();
  },
  methods: {
    fileChanged(){
      if(this.imgEncabezado == null){
        this.save = false;
        this.del = false;
      }
      else{
        this.save = true;
        this.del = false;
      }
    },
    async guardarImgEncabezado () {
      var self = this;
      self.loadingSave = true;
      self.snackbarError = false;
      self.textoError = "";
      
      try {
        let response = await postEiArchivoEncuesta(self.imgEncabezado, self.objEncuesta.idEncuesta, self.objEncuesta.tokenEncuesta);
        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.snackbarTexto = "Imagen guardada con éxito.";
              self.snackbarColor = "success";
              self.snackbar = true;
              self.loadingSave = false;
              self.obtenerEiArchivoImgEncabezado();
            }
          } else {
            self.snackbarTexto = "InfoEncuesta.guardarImgEncabezado: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loadingImg = false;
          }
        } else {
          self.snackbarTexto = "InfoEncuesta.guardarImgEncabezado: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loadingImg = false;
        }
      } catch (e) {
        self.loadingImg = false;
        self.snackbarTexto = "InfoEncuesta.guardarImgEncabezado: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    async obtenerEiArchivoImgEncabezado () {
      var self = this;
      self.loadingImg = true;
      self.imgEncabezado = null;      
      self.snackbarError = false;
      self.textoError = "";
      self.del = false;
      self.save = false;

      try {
        let response = await getEiArchivoEncuestaByIdEncuestaToken(self.objEncuesta.idEncuesta, self.objEncuesta.tokenEncuesta);
        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              if(response.data.data != null){
                this.imgEncabezado = new File([response.data.data.docto], response.data.data.nombreArchivo, {
                                                type: response.data.data.contenttype,
                                              });
                this.del = true;
                this.save = false;
              }
              self.loadingImg = false;
            }
          } else {
            self.snackbarTexto = "InfoEncuesta.obtenerEiArchivoImgEncabezado: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loadingImg = false;
          }
        } else {
          self.snackbarTexto = "InfoEncuesta.obtenerEiArchivoImgEncabezado: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loadingImg = false;
        }
      } catch (e) {
        self.loadingImg = false;
        self.snackbarTexto = "InfoEncuesta.obtenerEiArchivoImgEncabezado: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    async deleteImagenEncabezado () {
      var self = this;
      self.loadingSave = true;
      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await deleteEiArchivoEncuesta(self.objEncuesta.idEncuesta, self.objEncuesta.tokenEncuesta);
        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Archivo eliminado con éxito.") {
              self.snackbarTexto = response.data.message;
              self.snackbarColor = "success";
              self.snackbar = true;
              self.loadingSave = false;
              self.dialogEliminarImg = false;
              self.obtenerEiArchivoImgEncabezado();
            }
          } else {
            self.snackbarTexto = "InfoEncuesta.deleteImagenEncabezado: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loadingSave = false;
          }
        } else {
          self.snackbarTexto = "InfoEncuesta.deleteImagenEncabezado: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loadingSave = false;
        }
      } catch (e) {
        self.loadingSave = false;
        self.snackbarTexto = "InfoEncuesta.deleteImagenEncabezado: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    getDateFormated(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY hh:mm a');
      }
      else{
        return 'N/D';
      }
    },
  }
};
</script>